export function humanizeString(input: string) {
    return (
        input.charAt(0).toLocaleUpperCase() +
        input.substr(1).toLocaleLowerCase().replace(/[A-Z]/g, ' $&').replace(/_/g, ' ')
    );
}

export function removeUnderscores(input: string) {
    return input.replace(/_/g, ' ');
}

export function slugCase(input: string) {
    return input
        .replace(/[\s_]+/g, '-')
        .replace(/[^a-zA-Z1-9-]/g, '')
        .toLowerCase();
}

export function upperCaseEachWord(input: string) {
    const splitArray = input.split(' ');
    const stringArray = [];

    for (const segment of splitArray) {
        stringArray.push(segment.charAt(0).toUpperCase() + segment.slice(1));
    }

    return stringArray.join(' ');
}

export function tryPrintPercentage(input: number) {
    if (input == 0) {
        return 0;
    } else if (input > 0 && input <= 1) {
        return Math.trunc(input * 100) + '%';
    } else {
        return input;
    }
}

export function humanizeBytes(bytes: number) {
    if (Math.abs(bytes) < 1024) {
        return bytes + ' B';
    }
    const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let u = -1;
    do {
        bytes /= 1024;
        ++u;
    } while (Math.abs(bytes) >= 1024 && u < units.length - 1);
    return bytes.toFixed(1) + ' ' + units[u];
}
